<template>
  <div class="seedsuite_tags">
    <div class="vx-card p-6">
      <vs-tabs>
        <vs-tab label="Package Tags">
          <div class="tab-text">
            <TagListTable tagType="MedicalPackage" status="not used" />
          </div>
        </vs-tab>
        <vs-tab label="Plant Tags">
          <div class="tab-text">
            <TagListTable tagType="MedicalPlant" status="not used" />
          </div>
        </vs-tab>
        <vs-tab label="Used Package Tags">
          <div class="tab-text">
            <TagListTable tagType="MedicalPackage" status="used" />
          </div>
        </vs-tab>
        <vs-tab label="Used Plant Tags">
          <div class="tab-text">
            <TagListTable tagType="MedicalPlant" status="used" />
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import TagListTable from '@/views/seedsuite-tags/components/TagListTable'

export default {
  name: 'SeedSuiteTags',

  components: {
    TagListTable
  }
}
</script>

<style></style>
